import React from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { useTranslation } from '@/hooks/useTranslation';

type RULToolViewProps = {
  className?: string;
  toolId: string;
};

export const RULToolView: React.FC<RULToolViewProps> = ({ className = '', toolId: _toolId }) => {
  const { t } = useTranslation();

  return (
    <Card
      as="section"
      padding="lg"
      aria-label={t('toolView.rul.title')}
      className={cn('flex w-full flex-col space-y-4 transition-colors', className)}
    >
      <header>
        <h2 className="section-title">{t('toolView.rul.title')}</h2>
      </header>

      <div className="flex flex-col items-center gap-3 py-4 text-center text-muted-foreground">
        <p className="text-base font-medium">{t('toolView.rul.comingSoon.title')}</p>
        <p className="max-w-md text-sm">{t('toolView.rul.comingSoon.description')}</p>
      </div>
    </Card>
  );
};

export default RULToolView;
